import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './loanmortgageinsurance.css';
import parse from 'html-react-parser';

function LoanMortgageInsurance({ data }) {
  // Safe parsing function to handle undefined content
  const safeParse = (content) => {
    if (content === undefined || content === null) return '';
    return parse(content.toString());
  };
 
  // If no data is provided, don't render the component
  if (!data) return null;

  const { title, description, insuranceTypes } = data;

  return (
    <div className="loan-mortgage-insurance-section">
      <Container>
        <Row className="justify-content-center">
          <Col lg={12} className="text-center mb-4">
            <h2 className="loan-mortgage-insurance-title">{safeParse(title)}</h2>
            <p className="loan-mortgage-insurance-description">{safeParse(description)}</p>
          </Col>
        </Row>

        <div className="mortgage-dotted-line-wrapper">
          <Row className="insurance-types-container justify-content-center">
            {insuranceTypes && insuranceTypes.length > 0 && (
              <>
                {insuranceTypes.map((item, index) => (
                  <Col
                    key={index}
                    lg={insuranceTypes.length === 1 ? 6 : 6}
                    md={insuranceTypes.length === 1 ? 8 : 6}
                    className="insurance-type-col"
                  >
                    <div className="insurance-type-box">
                      <h3 className="insurance-type-title">{safeParse(item.title)}</h3>
                      <p className="insurance-type-description">{safeParse(item.description)}</p>
                    </div>
                  </Col>
                ))}
              </>
            )}
          </Row>
        </div>

        {data.additionalInfo && (
          <Row className="justify-content-center">
            <Col lg={12} className="text-center">
              <p className="additional-insurance-info">{safeParse(data.additionalInfo)}</p>
            </Col>
          </Row>
        )}

        {data.tableData && (
          <Row className="justify-content-center mt-3">
            <Col lg={10} className="text-center">
              <h3 className="nonqm-title">{parse(data.tableData.sectionTitle)}</h3>
              <table className="nonqm-table">
                <thead>
                  <tr>
                    {data.tableData.columns.map((column, colIndex) => (
                      <th
                        key={colIndex}
                        className="nonqm-table-header"
                        style={{ backgroundColor: column.backgroundColor || '#000' }}
                      >
                        {parse(column.title)}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {data.tableData.rows.map((row, rowIndex) => (
                    <tr key={rowIndex} className="nonqm-table-row">
                      {data.tableData.columns.map((column, colIndex) => (
                        <td key={colIndex} className="nonqm-table-cell">
                          {parse(row[column.key])}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="nonqm-disclaimer mt-3 mb-3">
                {parse(data.tableData.disclaimer)}
              </div>
            </Col>
          </Row>
        )}


      </Container>
    </div>
  );
}

export default LoanMortgageInsurance;